import { DefaultInvoiceProgressFilter } from "../InvoiceProgressFilter";

export interface InvoiceProgressFilterType {
  option: InvoiceProgressFilterOption
}

export interface InvoiceProgressFilterOption {
  label: string
  value: server.dto.InvoiceLifeCycleFilterOptions
}

export const InvoiceProgressOptions: InvoiceProgressFilterOption[] = [
  {
    label: RESX.DocumentLifeCycle.Draft,
    value: "draft"
  },
  {
    label: RESX.DocumentLifeCycle.Review,
    value: "review"
  },
  {
    label: RESX.Financial.Outstanding,
    value: "outstanding"
  },
  {
    label: RESX.Financial.OutstandingAndOverDueDate,
    value: "outstandingOverdue"
  },
  {
    label: RESX.Financial.Settled,
    value: "settled"
  }
];

export const getOption = (value: server.dto.InvoiceLifeCycleFilterOptions) => {
  return (
    InvoiceProgressOptions.find((s) => s.value === value) ?? {
      label: "",
      value: "unknown"
    }
  );
};

export const initialInvoiceProgressFilter: InvoiceProgressFilterType = {
  option: getOption(DefaultInvoiceProgressFilter)
};
